import { useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function OAuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();

  const payload = useMemo(() => {
    const hash = location.hash.startsWith("#") ? location.hash.slice(1) : location.hash;
    const hashParams = new URLSearchParams(hash);
    const queryParams = new URLSearchParams(location.search);

    return {
      token: hashParams.get("token") || queryParams.get("token"),
      role: hashParams.get("role") || queryParams.get("role"),
      firstname: hashParams.get("firstname") || queryParams.get("firstname") || "",
      lastname: hashParams.get("lastname") || queryParams.get("lastname") || "",
      profileCompleted: (hashParams.get("profileCompleted") || queryParams.get("profileCompleted") || "0") === "1",
      error: queryParams.get("error") || "",
    };
  }, [location.hash, location.search]);

  useEffect(() => {
    if (payload.error) {
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      localStorage.removeItem("firstname");
      localStorage.removeItem("lastname");
      localStorage.removeItem("profileCompleted");
      localStorage.removeItem("authProvider");
      localStorage.removeItem("emailVerified");
      navigate(`/login?oauthError=${encodeURIComponent(payload.error)}`, { replace: true });
      return;
    }

    if (!payload.token) {
      navigate("/login?oauthError=missing_token", { replace: true });
      return;
    }

    localStorage.setItem("token", payload.token);
    localStorage.setItem("role", payload.role || "");
    localStorage.setItem("firstname", payload.firstname);
    localStorage.setItem("lastname", payload.lastname);
    localStorage.setItem("authProvider", "google");
    localStorage.setItem("profileCompleted", payload.profileCompleted ? "true" : "false");
    localStorage.setItem("emailVerified", "false");

    if (!payload.profileCompleted) {
      navigate("/complete-profile", { replace: true });
      return;
    }

    if (payload.role === "owner") {
      navigate("/owner-dashboard", { replace: true });
      return;
    }

    if (payload.role === "renter") {
      navigate("/renter-dashboard", { replace: true });
      return;
    }

    navigate("/", { replace: true });
  }, [navigate, payload]);

  return (
    <div className="container py-5">
      <div className="alert alert-info" role="status">
        Completing sign-in, please wait...
      </div>
    </div>
  );
}

export default OAuthCallback;
